module.exports = {

	language: {
		name: '简体中文'
	},
	
	header: {
		1: '链接钱包',
		2: '首页',
		3: '关于',
		4: '功能',
		5: '预约',
		6: '模式',
		7: '安全'
	},
	indexyx: {
		1: 'Valla phone邀您共享这一广阔蓝海',
		2: '将联合行业头部企业POWERED BPOUVERED B明星项目启动第一期价值500W美金的空投计划',
		3: "预约支付",
		4: "邀请列表",
		5: "邀请人数",
		6: "地址",
		7: "Web3刚代的先锋",
		8: "专为多链生态系统设计的智能手机",
		9: "预计到",
		10: "年",
		11: "市场价值",
		12: "将飙升至",
		13: "万",
		14: "亿美元",
		15: "为多链生态系统量身打造的移动生态系统开启Web3世界的最佳入口",
		16:"充值成功",
		17:"充值失败",
		18:"余额不足",
		
	},
	indexfl:{
		1:"Valla phone邀您共享这一广阔蓝海",
		2:"FLOKI Token是一种加密货币，最初源自一个社区驱动的项目。 FLOKI 的名称和品牌灵感来自于著名的加密货币狗狗币（Dogecoin）的创始人——埃隆·马斯克（ElonMusk）宠物狗的名字，它的形象非常受社区欢迎。FLOKI 作为一个修改狗狗币的社区主导项目，旨在建立一个广泛的生态系统，包含多个不同的功能和应用。",
		3:"Vallhal&Valla phone是什么？",
		4:"FLOKI Token是一种加密货币，最初源自一个社区驱动的项目。 FLOKI 的名称和品牌灵感来自于著名的加密货币狗狗币（Dogecoin）的创始人——埃隆·马斯克（ElonMusk）宠物狗的名字，它的形象非常受社区欢迎。FLOKI 作为一个修改狗狗币的社区主导项目，旨在建立一个广泛的生态系统，包含多个不同的功能和应用。",
		5:"VALHALLA是Floki旗下首款元宇宙游戏，旨在通过向世界上最大的游戏市场推出一款有趣且创新的游戏，打造世界上最成功的加密游戏。",
		6:"Valla phone是由Valhalla推出的Web3领域首个“AI旗舰手机”，通过wb3手机用户可以更好的进入元宇宙的世界、通过创新和探索DePIN、AI潜力的释放将Web3设备带入了一个全新发展路径，同时为Valhalla用户提供无缝的加密货币管理、去中心化应用(DApp)访问以及全链游戏体验。也满足了不同用户在去中心化金融(DeFi)、NFT和Web3应用场景中的需求。",
		
	},
	indexfz:{
		1:"手机发展轨迹",
		2:"从“砖头”到Web3，手机经历了巨大的变化，Vallaphone正引领着进入未来的浪潮。你准备好加入这场革命了吗？",
		3:"回到上世纪80年代，当第一部移动电话摩托罗拉DynaTAC问世时！虽然这款“砖头”手机笨重且价格不菲，但在当时却是划时代的突破。真是进步飞速！",
		4:"时光飞逝，如今手机不仅仅是用来打电话的工具。Vallaphone来了，引领移动创新的下一波浪潮，融入Web3、去中心化技术和隐私优先的功能。",
		5:"从携带“砖头”到拥有一部能赚取代币的安全Web3手机，移动未来已经到来。Vallaphone不仅仅是一个设备，它是进入去中心化技术世界的入口。",
		6:"从最初的笨重、迟缓的设备，到如今既轻薄又快速、安全的技术，Vallaphone不仅是让你保持联系，更是让你掌控一切。",
	},
	indexsj:{
		1:"Web3名链手机 Valla phone",
		2:"代理模式",
		3:"手机价格:",
		4:"部",
		5:"首批",
		6:"台 ",
		7:"台以后",
		8:"代理权益:",
		9:"1.推荐者送价值1000u的Floki万分之3释放",
		10:"1.代理商销售到300部手机直接奖励价值30万车/房或者现金(代理商申请流程必须一次性预定10部手机)",
		11:"2.代理商手机可进行二次销售自行处理",
		12:"销售模式",
		13:"1.手机一部,发货周期两月左右。",
		14:"2.购买者送价值1000u的Floki3/10000释放。",
		15:"3.拿到手机后一年之内空投不低于50个机构投资的优质项目。",
		16:"4.Valhalla官方前500部手机每部手机空投1000枚Val平台代币上线以后根据价格递减赠送（500部后上线）价值无限。",
		17:"5.代理商销售到300部手机直接奖励价值30万车或者房或者现金(代理商申请流程必须一次性预定10部手机,手机也可二次销售自行处理。)",
		18:"首批",
	},
	indexzs:{
		1:"功能亮点",
		2:"将联合行业头部企业明星项目启动第一期价值500W美金的空投计划",
		3:"流 畅",
		4:"智 能",
		5:"玩 转",
		6:"融合Ai与Web3技术为Web3世界而设计",
		7:"由Android提供支持",
		8:"邀请代币奖励",
		9:"邀请人数",
		10:"直接",
		11:"间接",
		12:"提取",
		13:"邀请记录",
		14:"时间",
		15:"类型",
		16:"数量",
		17:"提取成功",
		18:"提取失败",
		19:"余额",
		20:"请输入提取数量",
		21:"余额不足",
		22:"支付",
		23:"奖励",
		24:"提取",
		25:"价格",
		26:"我的",
		27:"我的购买",
		28:'暂未开放'
		
	},
	indexjc:{
		1:"集成去中心化应用",
		2:"无缝体验web3世界",
		3:"Valla phone不仅是一个多链钱包，更是一个全面集成去中心化应用(DApp)生态系统的平台。用户可以直接通过Valla phone访问各类去中心化应用，无需下载和切换多个应用，极大地提升了用户体验。",
		4:"DAPP生态整合",
		5:"用户可以直接在Vallaphone内访问支持的DApp，涵盖了DeFi、NFT、游戏、社交等多个用户体验将不再受限于传统的浏览器或钱包应用。",
		6:"Web3一体化体验",
		7:"不仅支持去中心化应用，Vallaphone还提供基于Web3的功能，如去中心化社交、去中心化金融服、NFT交易平台等，为用户提供全面的去中心化生态体验 。",
		
	},
	aq:{
		1:"强化的安全性",
		2:"在加密货币和区块链领域，安全性一直是用户最关心的问题之一。Valla phone 通过集成创新的硬件安全模块，确保用户的数字资产和私人信息得到最高级别的保护。",
		3:"硬件钱包集成",
		4:"Valla phone手机内置的硬件安全块为加密资产提供物理隔离，私钥、签名等敏感信息都存储在独立的硬件模块中，极大降低了黑客攻击的风险。",
		5:"多重认证机制",
		6:"除了传统的PIN码和指纹识别外，MultiAPP 还支持生物识别技术(如面部识别)以及二次验证，以进一步增强安全性。",
		7:"防篡改机制",
		8:"设备内置防篡改硬件，确保用户的私钥和敏感信息在设备被盗或被篡改时仍然得到保护。",
		
	},
	yh:{
		1:"优化的用户体验",
		2:"Valla phone 致力于提供一个直观、易于使用的多链钱包和DApp平台，简化用户的操作流程，让加密货币的管理和跨链交易变得更加便捷。",
		3:"简化的跨链操作",
		4:"用户只需通过简单的几步操作，就能完成多链资产的管理与交易，无需繁琐的地址复制或复杂的交易流程。所有操作都可以在Vallaphone的单一界面上完成，极大提高了用户的操作效率",
		5:"个性化设置与智能推荐 一键管理多个钱包",
		6:"对于持有多种加密资产的用户，Va.phone提供一键管理多个钱包和资产的能，用户可以方便地在不同的链上进 行切换和查看，减少了繁琐的操作步骤。验",
		
	},
	lucky:{
		1:"首批用户福利满满",
		2:"打造世界最强Wbe3手机!",
		3:"市场机遇",
		4:"Valla phone 致力于提供一个直观、易于使用的多链钱包和DApp平台，简化用户的操作流程，让加密货币的管理和跨链交易变得更加便捷。",
		5:"未来几年的市场将迎来多个重要的变革，尤其是加密货币与区 块链技术的广泛普及。随着、NFT(非同质化代去中心化金融(DeFi)币)以及Web3应用的快速发展，全球用户对于多链生态 系统的需求将急剧上升。Valla phone凭借其多链技术的创新，正处于这一市场爆发的风口浪尖。",
		6:"到2025年，全球多链市场的规模预计将达到5000亿美元，而到2030年这-数字有望突破1万亿美元。",
		7:"随着区块链技术的普及与全球用户对加密货币认知的提高，预计全球加密货币用户将突破5亿。这将带动多链设备、钱包以及应用的需求",
		8:"Web3和去中心化应用的市场预计将在2030年前达到5万亿美元的市值，这为多链手机和生态系统提供了巨大增长空间",
	},
	
}
